import { Injectable } from '@angular/core';
import {
  CanLoad,
  Route,
  Router,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AccountsService } from "@services/accounts.service";
import { first, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class OnlyProGuard implements CanLoad {
  constructor(private accounts: AccountsService, private router: Router) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.accounts.hasProWinerySubscription().pipe(
      first(),
      map((pro) =>
        pro ? true : this.router.parseUrl('/homepage')
      )
    );
  }
}
